import axios from "axios";
import { trim } from "lodash";
import React, { useEffect, useState } from "react";
import {
    Link,
    useNavigate,
    useParams,
    useSearchParams
} from "react-router-dom";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowLeft } from "react-icons/bs";
import GallaryBox from "../../../Components/Global/GallaryBox";
import Loader from "../../../Components/Global/Loader";
import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import useMultipleImgUpload from "../../../hooks/useMultipleImgUpload";

function AddTask({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
  const {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  } = useMultipleImgUpload();

  const { designation } = useAuth();
  const route = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [priorityOption, setPriorityoption] = useState([
    {
      id: "1",
      name: "Low",
    },
    {
      id: "2",
      name: "High",
    },
    {
      id: "3",
      name: "Normal",
    },
  ]);

  const [covertTaskImage, setcovertTaskImage] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showImage, setShowimage] = useState();
  const [errorMessage, setErrorMessage] = useState({});
  const [priorityStatus, setPrioritystatus] = useState();
  const [TenantID, setTenantID] = useState();
  const [workerValue, SetWorkerValue] = useState([]);
  const [buildinglist, setBuildinglist] = useState();
  const [unitlist, setUnitlist] = useState();

    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;
  const [taskData, setTaskData] = useState({
    task_description: "",
    task_image: "",
    task_title: "",
    owner_name: "",
    task_category: "",
    building_name: "",
    building_id: "",
    unit_name: "",
    unit_id: "",
    tenant_name: "",
    tenant_name: "",
    priority: "",
    deadline: "",
    worker_id: "",
    receiver_status: "",
  });
  const {
    task_description,
    task_image,
    task_title,
    owner_name,
    task_category,
    unit_name,
    building_name,
    tenant_name,
    priority,
    deadline,
    worker_id,
    building_id,
    receiver_status,
    unit_id,
  } = taskData;

  const ID = useParams();
  const { id: alreadyTaskId } = useParams();
  const Task_Id = ID?.id;
  const TaskId = searchParams.get("taskid");
  const request_convert_task_id = searchParams.get("taskid");

  const validation = () => {
    const errors = {};

    if (!task_title || !trim(task_title)) {
      errors.task_title = "Please enter your task title.";
    }
    if (!building_id || !trim(building_id)) {
      errors.building_name = "Please choose building name.";
    }
    if (unitlist?.length > 0) {
      if (!unit_id || !trim(unit_id)) {
        errors.unit_name = "Please choose unit name.";
      }
    }

      const isActive = workerValue.find(act=>act.id==worker_id) 
      
  
    
    if (!worker_id || !trim(worker_id)) {
      errors.worker_id = "Please choose your Worker name.";
    }else{
      if(isActive.status==false){
       
        errors.worker_id = "Worker is inactive.";
      
      }
    }
    if (!receiver_status || !trim(receiver_status)) {
      errors.receiver_status = "Please choose your task status.";
    }
    if (!deadline || !trim(deadline)) {
      errors.deadline = "Please enter your lease end date.";
    }

    if (selectedImages?.length > 10) {
      errors.imgs = "Please choose images less than 10";
    }

    return errors;
  };

  useEffect(() => {
    if (TaskId) {
      getRequestList();
      getWorkerRequestList();
    }
    if (Task_Id) {
      getTaskValue();
      getWorkerRequestList();
      SearchListFunc();
    } else {
      SearchListFunc();
      getWorkerRequestList();
    }
  }, [TaskId, Task_Id]);

  useEffect(() => {
    if (building_id) {
      UnitListFunc();
    }
  }, [building_id]);

  const onClickImages = (url) => {
    setShowimage(url);
  };
  const SearchListFunc = () => {
    // setLoading(true);
    // SelectSearchBuildingList()
    //   .then((res) => {
    //     if (res?.data) {
    //       setBuildinglist(res?.data?.building);
    //       // setLoading(false);  
    //     }
    //   })
    //   .catch((e) => {
    //     // setLoading(false);
    //   });
  };

  const UnitListFunc = () => { };
  const getTaskValue = () => {
    if (request_convert_task_id == null) {
      axiosFetch({
        axiosInstance: axios,
        method: "GET",
        url: `/task/show/${alreadyTaskId}`,
      })
        .then((response) => {
          setTaskData({
            ...response?.data?.TaskList,
            building_id: response.data?.TaskList?.buildingId?.id,
            building_name: response.data?.TaskList?.buildingId?.building_name,
            unit_id: response.data?.TaskList?.unit_id,
            unit_name: response.data?.TaskList?.unitId?.unit_name,
            deadline: new Date(response?.data?.TaskList?.deadline),
          });
          setSelectedImages(
            response.data?.TaskList?.task_image
              ? JSON.parse(response.data?.TaskList?.task_image)?.map((img) => ({
                url: img,
              }))
              : []
          );
          setcovertTaskImage(
            response.data?.TaskList?.task_image
              ? JSON.parse(response.data?.TaskList?.task_image)
              : []
          );
          setPrioritystatus(response.data.TaskList?.priority);
        })
        .catch((e) => { });
      return;
    }

    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/request/show/${request_convert_task_id}`,
    })
      .then((response) => {
        setTaskData({
          ...response.data,
          building_id: response.data?.building_id,
          building_name: response.data?.building_name,
          unit_id: response.data?.unit_id,
          unit_name: response.data?.unit_name,
          task_description: response.data?.description
        });
        setSelectedImages(
          response.data?.request_image
            ? JSON.parse(response.data?.request_image)?.map((img) => ({
              url: img,
            }))
            : []
        );
        setcovertTaskImage(
          response.data?.request_image
            ? JSON.parse(response.data?.request_image)
            : []
        );
      })
      .catch((e) => { });
  };

  useEffect(() => {
    if (request_convert_task_id !== null) {
      getTaskValue();
    }
  }, [request_convert_task_id]);

  const getRequestList = () => { };
  const getWorkerRequestList = () => {
    // WorkerRequestList()
    axiosFetch({
      axiosInstance: axios,
      method: "POST",
      url: `/worker/list`,
      requestConfig: {
        page: 1,
        record: 5,
        search: "",
      },
    })
      .then((response) => {
        SetWorkerValue(response.data?.result?.rows);
      })
      .catch((e) => {
        // setLoading(false);
        //(e);
      });
  };

  const handleData = (e) => {
    setErrorMessage({});
    const { value, name } = e.target;
  
  
 if (name == "priority") {
      let data = e.target.value;
      setTaskData({ ...taskData, priority: data });
      setPrioritystatus(e.target.value);
    }
    else{
      setTaskData({ ...taskData, [e.target.name]: value });
      if(name == "worker_id"){

const isActive = workerValue.find(act=>act.id==e.target.value) 
setErrorMessage(isActive.status==false &&{worker_id:"Worker is inactive"});
      }
    }

  };

  const SubmitTask = (e) => {
    e.preventDefault();
    const abc = validation();

    if (Object.keys(abc).length === 0) {
      setLoading(true);
     
      const filterImages = selectedImages?.filter(
        (file) => !file.url.includes("blob:")
      );
      const removeUrlTag = filterImages?.map((img) => img.url);
      if (selectedImages.length === 0) {
        taskFuncWithImg([]);
      } else if (
        selectedImages.filter((img) => img.file !== undefined).length == 0
      ) {
        taskFuncWithImg(removeUrlTag);
      } else {
        uploadToserver("task_image")
          .then((res) => {
            setImgLinks(res?.data?.links);
            taskFuncWithImg([...res?.data?.links, ...removeUrlTag]);
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    } else {
      setErrorMessage(abc);
    }
  };



  const taskFuncWithImg = (imagesss) => {
    setErrorMessage();

    // return
    let data = taskData;
    data = {
      ...taskData,
      task_image: JSON.stringify(imagesss),

      id: TaskId,
      task_category: task_category,
      task_title: task_title,
      unit_name: unit_name,
      building_name: building_name,
      tenant_id: TenantID,
    };
    if (TaskId) {
      data = {
        ...data,

        task_image: JSON.stringify(covertTaskImage),
      };
    }

    if (request_convert_task_id) {
      data = { ...data, request_id: request_convert_task_id };
    }
    setLoading(true);

    if (!Task_Id) {
      axios.post(Task_Id ? `/task/update/${Task_Id}` : "/task/create", data).then(function (response) {
        if (response.status === 200) {
          setLoading(false);
          route(
            designation === "Owner" || designation === "Partner"
              ? "/tasklist"
              : `/${designation?.toLowerCase()}/tasklist`
          );
          // route("/tasklist");
        }
      }).catch(function (error) {
        setLoading(false);
      });
    } else {
      axios
        .post(`/task/update/${Task_Id}`, data)
        .then(function (response) {
          setLoading(false);
          route(
            designation === "Owner" || designation === "Partner"
              ? "/tasklist"
              : `/${designation?.toLowerCase()}/tasklist`
          );
        })
        .catch(function (error) {
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    axiosFetch({
      axiosInstance: axios,
      method: "post",
      url: "building/list",
    }).then((res) => {
      setBuildinglist(res?.data?.result?.rows);
    });
  }, []);
  useEffect(() => {
    if (building_id) {
      axiosFetch({
        axiosInstance: axios,
        method: "post",
        url: `/unit/list/${building_id}`,
        requestConfig: {
          page: 1,
          recored: 5,
          search: "",
        },
      }).then((res) => {
        setUnitlist(res?.data?.result?.rows);
      });
    }
  }, [building_id]);




  // const  { formState, dispatch }=useFormHandler()

  // const { 
  //   building_name,
  //   building_code,
  //   street_address,

  //   city,
  //   province,
  //   country,
  //   postal_code,
  //   image,
  //   Description,
  //   status,
  //   Assigns,

  // }=formState.buildingInformations;




  return (
    <>
      <DashboardLayouts>
        {(allowLoading || loading) && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="col-xl-6 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link
              to={
                designation === "Owner" || designation === "Partner"
                  ? "/dashboard"
                  : `/${designation}dashboard`.toLowerCase()
              }
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard</h3>
            </Link>
          </div>
        </div>

        <div className="worker-heading w-100">
          <h1 className="heading-text mb-3 mb-lg-5">
            {" "}
            {TaskId || Task_Id ? "Edit Task" : "Add Task"}
          </h1>
        </div>

        <div className="add-request-form row gy-4">
          <div className="col-xl-7 col-xxl-8">
            <form action="" className="dash-form add-form">
              <div className="row gy-lg-4 gy-2">
                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-lbl">
                    {TaskId ? "Request Task" : "Task Title"}{" "}
                    <span className="must-field">*</span>
                  </label>
                  <div className="form-group">
                    <input
                      type="text"
                      value={task_title}
                      name="task_title"
                      id="task_title"
                      onChange={(e) => handleData(e)}
                      className={`form-control form-g1`}
                      placeholder="Task title"
                    />
                    {errorMessage?.task_title ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.task_title}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-lbl">
                    Building <span className="must-field">*</span>
                  </label>
                  <div className="form-group">
                    {TaskId || taskData?.request_id != null ? (
                      <input
                        type="text"
                        value={building_name}
                        name="building_name"
                        id="building_name"
                        readOnly
                        // onChange={(e) => handleData(e)}
                        className={`form-control form-g1`}
                        placeholder="Building Name"
                      />
                    ) : (
                      <>
                        <select
                          type="text"
                          value={building_id}
                          name="building_id"
                          id="building_id"
                          onChange={(e) => handleData(e)}
                          className={`form-control form-g1`}
                        >
                          <option value="">Choose Building</option>;
                          {buildinglist?.map((list, i) => {
                            return (
                              <option key={i} value={list.id}>
                                {list.building_name}
                              </option>
                            );
                          })}
                        </select>
                        {errorMessage?.building_name ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.building_name}
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-lbl">
                    Unit <span className="must-field">*</span>
                  </label>
                  {TaskId || taskData?.request_id != null ? (
                    <div className="form-group">
                      <input
                        type="text"
                        name="unit_name"
                        id="unit_name"
                        value={unit_name}
                        readOnly
                        // onChange={(e) => handleData(e)}
                        className={`form-control form-g1`}
                        placeholder="Unit"
                      />
                    </div>
                  ) : (
                    <div className="form-group">
                      <select
                        type="text"
                        name="unit_id"
                        id="unit_id"
                        value={unit_id}
                        onChange={(e) => handleData(e)}
                        className={`form-control form-g1`}
                      >
                        <option value="">Choose Unit</option>
                        {unitlist?.length > 0 ? (
                          unitlist?.map((list, i) => {
                            return (
                              <option key={i} value={list.id}>
                                {list.unit_name}
                              </option>
                            );
                          })
                        ) : (
                          <option value="">No Unit Name</option>
                        )}
                      </select>
                      {errorMessage?.unit_name ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.unit_name}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>

                <div className="col-xl-6 col-md-6 mb-3">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Choose Task Category
                    </label>

                    <select
                      type="text"
                      name="task_category"
                      value={task_category}
                      onChange={(e) => handleData(e)}
                      className="form-control form-g1"
                      id="form-request*"
                    >
                      <option value="">Choose</option>
                      <option value="Maintenance">Maintenance</option>
                      <option value="Accounts">Accounts</option>
                      <option value="Security">Security</option>
                      <option value="Legal">Legal</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-lbl">
                    Worker <span className="must-field">*</span>
                  </label>
                  <div className="form-group">
                    <select
                      id=""
                      value={worker_id}
                      name="worker_id"
                      onChange={(e) => handleData(e)}
                      className="form-control form-g1"
                    >
                      <option value=""> Choose worker</option>
                      {workerValue?.map((items, i) => {
                        return (
                          <option key={i} value={items.id}>
                            {items.first_name + " " + items.last_name}
                          </option>
                        );
                      })}
                    </select>
                    {(errorMessage?.worker_id )? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.worker_id }
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-lbl">
                    Status <span className="must-field">*</span>
                  </label>
                  <div className="form-group">
                    <select
                      id=""
                      value={receiver_status}
                      onChange={(e) => handleData(e)}
                      name="receiver_status"
                      className="form-control form-g1"
                    >
                      <option value="">Choose Status</option>
                      {alreadyTaskId && (
                        <option value="Completed">Completed</option>
                      )}
                      <option value="Pending">Pending</option>
                      <option value="In Progress">In Progress</option>
                    </select>

                    {errorMessage?.receiver_status ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.receiver_status}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-lbl">
                    Deadline <span className="must-field">*</span>
                  </label>
                  <div className="form-group">
                    <DatePicker
                      selected={deadline}
                      onChange={(date) => {
                        setTaskData({ ...taskData, deadline: date });
                      }}
                      minDate={new Date()}
                      placeholder={"DD/MM/YYYY"}
                      className="form-control form-g1"
                    />
                    {errorMessage?.deadline ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.deadline}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-xl-12">
                  <label htmlFor="" className="form-lbl">
                    Task Description
                  </label>
                  <textarea
                    type="text"
                    value={task_description}
                    name="task_description"
                    id="task_description"
                    onChange={(e) => handleData(e)}
                    className="form-control form-g1"
                    placeholder="Task Description"
                  ></textarea>
                </div>

                <div className="col-xl-6 form-radion-btn mb-1 mb-lg-2">
                  <div className="form-floating d-flex flex-wrap flex-md-nowrap">
                    <div>
                      <p className="unit-heading2 me-3">Priority :</p>
                    </div>
                    {priorityOption?.map((choice, index) => (
                      <div
                        key={index}
                        className="form-check d-flex align-items-center ps-0 form-radio-check "
                      >
                        <label
                          className="radio-lbl me-3"
                          htmlFor={`xyz${choice.id}`}
                        >
                          <input
                            onChange={(e) => handleData(e)}
                            type="radio"
                            className="formradio me-1"
                            id={`xyz${choice.id}`}
                            name="priority"
                            value={choice.name}
                            checked={priorityStatus?.includes(choice.name)}
                          />
                          {choice.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </form>
          </div>

          <GallaryBox request_id={taskData?.request_id} selectedImages={selectedImages} defaultImg={defaultImg} handleDefaultImage={handleDefaultImage} onSelectFile={onSelectFile} deleteHandler={deleteHandler} />
          <div className="mt-0 mt-lg-4">
            <button
              type="submit"
              onClick={(e) => {
                SubmitTask(e);
              }}
              className="btn btn-primary btn-lg fs-6 form-btn"
            >
              Create Task
            </button>
          </div>
        </div>
      </DashboardLayouts>
    </>
  );
}
export default AddTask;
